
    import Component from "vue-class-component";
    import Vue from "vue";
    import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";
    import {Prop} from "vue-property-decorator";

    @Component({
        components: {
            CardQuicklink
        }
    })
    export default class NewConcessionPermitCard extends Vue {
        @Prop({ default: 'seafarer-new-concession-permit-application' })
        routeName!: string;

        @Prop({ required: true })
        seafarerId!: string;
    }
